<template>
    <div class="rd-list">
        <loading
            :active.sync="open_loader"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#6366f1'"
        ></loading>

        <header class="rd-list__head">
            <div>
                <h1 class="rd-list__title">{{ app_owner === 'HKOIG' ? 'Skupovi' : 'Webinari' }}</h1>
                <p class="rd-list__sub">Pokrenite prijenos ili snimku.</p>
            </div>
            <router-link to="/" class="rd-back">← Natrag</router-link>
        </header>

        <div v-if="prijave.length === 0 && !open_loader" class="rd-empty">
            Trenutno nema aktivnih webinara.
        </div>

        <div v-else class="rd-cards">
            <template v-for="(prijava, index) in prijave">
                <article
                    v-for="(webinar, index2) in prijava.skupovi.webinars"
                    :key="index + '-' + index2"
                    class="rd-webinar"
                    @click.prevent="play(prijave[index], webinar)"
                >
                    <span class="rd-play" aria-hidden="true">▶</span>
                    <div class="rd-webinar__info">
                        <h2 class="rd-webinar__title">{{ prijava.skupovi.naziv }}</h2>
                        <h3 v-if="webinar.skupovi_teme && webinar.skupovi_teme.naziv != prijava.skupovi.naziv" class="rd-webinar__theme">
                            {{ webinar.skupovi_teme.naziv }}
                        </h3>
                        <div class="rd-webinar__date">{{ webinar.datum_od }}</div>
                        <div v-if="webinar.opis != prijava.skupovi.naziv" class="rd-prose rd-webinar__desc" v-html="webinar.opis"></div>
                    </div>
                </article>
            </template>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from 'toastr';

export default {
    name: "Webinai",
    components: {
        Loading,
    },
    data(){
        return {
            open_loader: false,
            app_owner: process.env.VUE_APP_APP_OWNER,
            prijave: []
        }
    },
    methods:{
        init(){
            let vm=this
            vm.open_loader=true
            axios.get( process.env.VUE_APP_API_URL + 'prijava', {
                params: {
                    options: {
                        korisnik_webinari: true
                    }
                }
            } )
                    .then( function ( response ) {
                        vm.prijave = response.data.data
                        vm.open_loader = false;
                    } )
                    .catch( function ( error ) {
                            vm.open_loader = false;
                            if(error instanceof Error) {
                                console.log( 'Error: ' + error);
                            } else {
                                console.log( 'Unexpected response: ' + error);
                            }
                        } )
        },

        play( prijava, webinar ){
            if( webinar.url ){
                axios( {
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + 'webinar-sudionik',
                    data: {
                        webinar_id: webinar.id,
                        prijava_id: prijava.id
                    }
                } )
                        .then( function( response ) {
                            if( response.data.success ){
                                window.open(webinar.url, "_blank");
                            } else {
                                toastr.error( 'Došlo je do greške' )
                            }
                        } )
                        .catch( function ( response ) {
                            console.log( response )
                        } )
            } else {
                toastr.error( 'Pokušajte kasnije' )
            }
        }

    },
    mounted() {
        this.init()
        this.interval = setInterval(() => this.init(), 500000);
    },
    beforeDestroy() {
        clearInterval( this.interval )
    }
}
</script>

<style scoped>
.rd-list__head {
    display: flex; align-items: flex-end; justify-content: space-between;
    gap: 1rem; margin-bottom: 1.75rem; flex-wrap: wrap;
}
.rd-list__title { font-size: 1.8rem; font-weight: 800; margin: 0; }
.rd-list__sub { color: var(--rd-muted, #6b7280); margin: .3rem 0 0; }

.rd-back {
    font-weight: 700; color: var(--rd-primary-600, #4f46e5);
    background: var(--rd-primary-50, #eef2ff); padding: .55rem 1.1rem;
    border-radius: 12px; white-space: nowrap; transition: background .15s ease;
}
.rd-back:hover { background: #e3e7ff; }

.rd-cards { display: flex; flex-direction: column; gap: 1.25rem; }

.rd-webinar {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    background: #fff;
    border: 1px solid var(--rd-border, #e6e8f0);
    border-radius: var(--rd-radius, 18px);
    box-shadow: var(--rd-shadow, 0 12px 28px -8px rgba(16,24,40,.14));
    padding: 1.5rem 1.75rem;
    cursor: pointer;
    transition: transform .15s ease, box-shadow .25s ease, border-color .2s ease;
}
.rd-webinar:hover {
    transform: translateY(-3px);
    box-shadow: var(--rd-shadow-lg, 0 24px 48px -12px rgba(31,28,86,.28));
    border-color: rgba(99,102,241,.45);
}

.rd-play {
    flex: 0 0 auto;
    width: 60px; height: 60px;
    display: flex; align-items: center; justify-content: center;
    border-radius: 50%;
    color: #fff;
    font-size: 1.3rem;
    background: var(--rd-gradient, linear-gradient(135deg, #6366f1, #7c3aed));
    box-shadow: 0 10px 22px -8px rgba(99,102,241,.7);
    transition: transform .2s ease;
    padding-left: 4px;
}
.rd-webinar:hover .rd-play { transform: scale(1.08); }

.rd-webinar__info { min-width: 0; }
.rd-webinar__title { font-size: 1.2rem; font-weight: 700; margin: 0 0 .2rem; }
.rd-webinar__theme { font-size: 1rem; font-weight: 600; color: var(--rd-primary-600, #4f46e5); margin: 0 0 .2rem; }
.rd-webinar__date { color: var(--rd-muted, #6b7280); font-weight: 600; font-size: .9rem; margin-bottom: .35rem; }
.rd-webinar__desc { color: #4a5165; font-size: .92rem; }
.rd-prose >>> img { max-width: 100%; height: auto; border-radius: 10px; }

.rd-empty {
    text-align: center; color: var(--rd-muted, #6b7280); background: #fff;
    border: 1px dashed var(--rd-border, #e6e8f0); border-radius: var(--rd-radius, 18px);
    padding: 3rem 1.5rem; font-size: 1.05rem;
}
</style>
